function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "a",
  x1: 20.13,
  y1: 32.48,
  x2: 20.13,
  y2: 7.96,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#fa233b"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#fb5c74"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.44,39.12h-.9A11.52,11.52,0,0,1,5.67,39,5.89,5.89,0,0,1,4,38.4a5.16,5.16,0,0,1-1.39-1,5.19,5.19,0,0,1-1-1.4,5.79,5.79,0,0,1-.55-1.66,12.1,12.1,0,0,1-.16-1.87c0-.21,0-.92,0-.92V8.44s0-.69,0-.89a12,12,0,0,1,.16-1.87A5.69,5.69,0,0,1,1.6,4a5.06,5.06,0,0,1,1-1.4A5.52,5.52,0,0,1,4,1.6a5.79,5.79,0,0,1,1.66-.55A12.1,12.1,0,0,1,7.54.89l.91,0H131.17l.91,0a11.88,11.88,0,0,1,1.86.16,5.75,5.75,0,0,1,1.67.55,5.38,5.38,0,0,1,1.4,1A5.78,5.78,0,0,1,138,4a5.6,5.6,0,0,1,.53,1.65,12.31,12.31,0,0,1,.18,1.88v.89c0,.38,0,.74,0,1.1V30.46c0,.37,0,.72,0,1.08v.93a13.12,13.12,0,0,1-.17,1.85A5.85,5.85,0,0,1,138,36a5.67,5.67,0,0,1-1,1.39,5.19,5.19,0,0,1-1.4,1,5.66,5.66,0,0,1-1.67.55,11.34,11.34,0,0,1-1.87.16H8.44Z",
  transform: "translate(0 0)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "140.62px",
    height: "41px",
    viewBox: "0 0 140.62 41"
  }, props), _ref, React.createElement("path", {
    d: "M130.09,0H7.52a13.51,13.51,0,0,0-2,.18,6.74,6.74,0,0,0-1.9.63A6.07,6.07,0,0,0,2,2,6.07,6.07,0,0,0,.82,3.62a6.74,6.74,0,0,0-.63,1.9,12.18,12.18,0,0,0-.17,2c0,.31,0,.62,0,.92V31.56c0,.31,0,.61,0,.92a12.18,12.18,0,0,0,.17,2,6.8,6.8,0,0,0,.63,1.91A6.19,6.19,0,0,0,2,38a6.07,6.07,0,0,0,1.62,1.18,6.74,6.74,0,0,0,1.9.63,13.51,13.51,0,0,0,2,.18H132.1a13.39,13.39,0,0,0,2-.18,6.91,6.91,0,0,0,1.91-.63A6.19,6.19,0,0,0,137.62,38a6.46,6.46,0,0,0,1.19-1.61,6.76,6.76,0,0,0,.61-1.91,12.2,12.2,0,0,0,.19-2v-.92c0-.36,0-.73,0-1.1V9.54c0-.37,0-.73,0-1.1V7.52a12.2,12.2,0,0,0-.19-2,6.7,6.7,0,0,0-.61-1.9A6.33,6.33,0,0,0,137.62,2,6.19,6.19,0,0,0,136,.82,6.91,6.91,0,0,0,134.1.19a13.39,13.39,0,0,0-2-.18h-2Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#a6a6a6"
    }
  }), _ref2, React.createElement("path", {
    d: "M42.12,14.75H38.41V8.8h.92v5.1h2.79Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M43.21,8.93a.55.55,0,0,1,.57-.55.55.55,0,1,1,0,1.09A.55.55,0,0,1,43.21,8.93Zm.13,1.33h.88v4.49h-.88Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M47.3,10.17c1,0,1.67.47,1.76,1.26h-.85c-.08-.33-.4-.54-.91-.54s-.87.24-.87.59.23.44.72.55l.74.17c.86.2,1.26.57,1.26,1.23,0,.84-.79,1.41-1.86,1.41s-1.77-.48-1.85-1.28h.89c.11.35.44.56,1,.56s.94-.25.94-.61-.21-.44-.66-.54l-.78-.19c-.86-.2-1.25-.58-1.25-1.25S46.29,10.17,47.3,10.17Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M51.52,9.14v1.14h1V11h-1v2.31c0,.47.19.67.63.67a1.83,1.83,0,0,0,.34,0v.74a2.36,2.36,0,0,1-.48,0c-1,0-1.38-.35-1.38-1.22V11h-.71v-.75h.71V9.14Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M57.42,13.54a1.83,1.83,0,0,1-2,1.3,2,2,0,0,1-2.07-2.32,2.07,2.07,0,0,1,2.07-2.35c1.25,0,2,.86,2,2.27v.31H54.3v.05a1.19,1.19,0,0,0,1.2,1.28,1.09,1.09,0,0,0,1.07-.54ZM54.3,12.09h2.27a1.08,1.08,0,0,0-1.11-1.16A1.15,1.15,0,0,0,54.3,12.09Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M58.67,10.26h.86V11h.06a1.36,1.36,0,0,1,1.35-.8,1.46,1.46,0,0,1,1.55,1.67v2.91H61.6V12.07c0-.73-.31-1.09-1-1.09a1,1,0,0,0-1.07,1.14v2.63h-.89Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M66.09,12.5a2.13,2.13,0,1,1,4.24,0,2.13,2.13,0,1,1-4.24,0Zm3.33,0c0-1-.44-1.54-1.21-1.54S67,11.53,67,12.5s.43,1.55,1.2,1.55S69.42,13.48,69.42,12.5Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M71.53,10.26h.86V11h.06a1.35,1.35,0,0,1,1.34-.8,1.46,1.46,0,0,1,1.56,1.67v2.91h-.89V12.07c0-.73-.31-1.09-1-1.09a1,1,0,0,0-1.07,1.14v2.63h-.89Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M46,27.84H41.3L40.16,31.2h-2l4.49-12.43h2.08L49.22,31.2h-2Zm-4.25-1.55h3.76L43.7,20.84h-.06Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M58.9,26.67c0,2.82-1.51,4.62-3.78,4.62a3,3,0,0,1-2.85-1.58h-.05V34.2H50.36V22.14h1.8v1.51h0A3.2,3.2,0,0,1,55.08,22C57.38,22,58.9,23.86,58.9,26.67Zm-1.91,0c0-1.83-1-3-2.4-3s-2.38,1.23-2.38,3,1,3,2.38,3S57,28.52,57,26.67Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M68.86,26.67c0,2.82-1.5,4.62-3.78,4.62a3.06,3.06,0,0,1-2.85-1.58h0V34.2H60.33V22.14h1.8v1.51h0A3.21,3.21,0,0,1,65.05,22C67.35,22,68.86,23.86,68.86,26.67Zm-1.91,0c0-1.83-1-3-2.39-3s-2.38,1.23-2.38,3,1,3,2.38,3S67,28.52,67,26.67Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M70.36,18.77h1.86V31.2H70.36Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M81.9,28.54c-.25,1.64-1.85,2.77-3.9,2.77-2.63,0-4.27-1.76-4.27-4.6S75.37,22,77.92,22,82,23.75,82,26.5v.63h-6.4v.12A2.35,2.35,0,0,0,78,29.81a2.06,2.06,0,0,0,2.1-1.27Zm-6.29-2.71h4.54a2.19,2.19,0,0,0-2.23-2.3A2.3,2.3,0,0,0,75.61,25.83Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M98.05,31.2V22.05H98l-3.75,9.06H92.81l-3.75-9.06H89V31.2H87.24V18.77h2.23l4,9.81h.07l4-9.81h2.24V31.2Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M109.72,31.2h-1.78V29.64h0a2.83,2.83,0,0,1-2.81,1.66A3,3,0,0,1,101.91,28V22.14h1.86v5.45c0,1.38.66,2.11,1.94,2.11a2.1,2.1,0,0,0,2.15-2.34V22.14h1.86Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M115,22c2,0,3.45,1.11,3.49,2.71h-1.75c-.08-.8-.76-1.29-1.79-1.29s-1.68.46-1.68,1.17c0,.54.45.9,1.39,1.14l1.52.35c1.83.44,2.52,1.11,2.52,2.44,0,1.63-1.55,2.75-3.77,2.75s-3.57-1.09-3.71-2.75h1.84c.13.87.83,1.34,2,1.34s1.81-.46,1.81-1.18c0-.56-.35-.86-1.29-1.1l-1.62-.4c-1.64-.4-2.47-1.23-2.47-2.49C111.46,23.13,112.9,22,115,22Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M120.16,19.75a1.08,1.08,0,1,1,1.07,1.06A1.07,1.07,0,0,1,120.16,19.75Zm.14,2.39h1.86V31.2H120.3Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M130.17,25.26A2,2,0,0,0,128,23.59c-1.43,0-2.38,1.19-2.38,3.08s1,3.09,2.4,3.09a1.94,1.94,0,0,0,2.11-1.63H132A3.63,3.63,0,0,1,128,31.31c-2.58,0-4.27-1.76-4.27-4.64S125.46,22,128,22A3.64,3.64,0,0,1,132,25.26Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff"
    }
  }), React.createElement("path", {
    d: "M32.71,15.29v-.9c0-.26,0-.51,0-.76A11.37,11.37,0,0,0,32.55,12,5.53,5.53,0,0,0,32,10.4a5.28,5.28,0,0,0-1-1.33,5.2,5.2,0,0,0-1.34-1,5.66,5.66,0,0,0-1.57-.51,11.37,11.37,0,0,0-1.65-.15H13.76a11.37,11.37,0,0,0-1.65.15,5.84,5.84,0,0,0-1.58.51A5.51,5.51,0,0,0,8.22,10.4,5.84,5.84,0,0,0,7.71,12a11.37,11.37,0,0,0-.15,1.65c0,.25,0,.5,0,.76V25.61c0,.25,0,.51,0,.76A11.37,11.37,0,0,0,7.71,28a5.84,5.84,0,0,0,.51,1.58,5.51,5.51,0,0,0,2.31,2.31,5.84,5.84,0,0,0,1.58.51,11.37,11.37,0,0,0,1.65.15H26.5a11.37,11.37,0,0,0,1.65-.15,5.66,5.66,0,0,0,1.57-.51,5.2,5.2,0,0,0,1.34-1,5.28,5.28,0,0,0,1-1.33A5.53,5.53,0,0,0,32.55,28a11.37,11.37,0,0,0,.15-1.65c0-.25,0-.51,0-.76V15.29Z",
    transform: "translate(0 0)",
    style: {
      "fillRule": "evenodd",
      "fill": "url(#a)"
    }
  }), React.createElement("path", {
    d: "M25.34,11.26l-.67.12-7.48,1.51h0a1,1,0,0,0-.47.21.75.75,0,0,0-.25.48,1.21,1.21,0,0,0,0,.25V23.2a.76.76,0,0,1-.71.89l-.49.09a8.38,8.38,0,0,0-1.38.36,2.1,2.1,0,0,0-.82.52,2,2,0,0,0-.52,1.56,2,2,0,0,0,.62,1.25,2,2,0,0,0,.91.47,3.59,3.59,0,0,0,1.35-.07,2.49,2.49,0,0,0,.87-.33,2.09,2.09,0,0,0,.69-.63,2.32,2.32,0,0,0,.37-.87,4,4,0,0,0,.08-.92V17.4c0-.44.13-.55.48-.64l6.5-1.31c.41-.07.6,0,.6.47v5.54a.9.9,0,0,1-.15.62.84.84,0,0,1-.55.28l-.49.1a8.24,8.24,0,0,0-1.38.35,2.22,2.22,0,0,0-.82.52,2,2,0,0,0-.53,1.57,2,2,0,0,0,.63,1.24,1.94,1.94,0,0,0,.91.47A3.59,3.59,0,0,0,24,26.54a2.93,2.93,0,0,0,.87-.32,2.12,2.12,0,0,0,.69-.64,2.44,2.44,0,0,0,.37-.86,4.17,4.17,0,0,0,.07-.93V11.92C26,11.49,25.74,11.23,25.34,11.26Z",
    transform: "translate(0 0)",
    style: {
      "fill": "#fff",
      "fillRule": "evenodd"
    }
  }));
};

export default __webpack_public_path__ + "static/media/listen-apple.7ef01c8c.svg";
export { SvgComponent as ReactComponent };